

import Default from './Components/Default';
import LoadMore from './Components/LoadMore';
import Message from './Components/Message';
import Playlist from './Components/Playlist';

const VideoLayout = ({ attributes, videos, callVideos, nextPageToken, preloader, isLoading }) => {

    const { columns, layout, configure } = attributes;
    const { perPage } = configure;

    return <><div className={`videoGallery ${layout} columns-${columns.desktop} columns-tablet-${columns.tablet} columns-mobile-${columns.mobile}`}>
        {videos?.length ? <>
            {(layout === 'default' || layout === "grid-details") && <Default attributes={attributes} videos={videos} />}
            {layout === "playlist" && <Playlist attributes={attributes} videos={videos} perPage={perPage} callVideos={callVideos} nextPageToken={nextPageToken} />}</>
            : !isLoading && <Message message={'No Videos Found!'} />}

    </div>
        {isLoading && <div className='ytvgbPreloader'>{preloader}</div>}
        {(layout !== "playlist" && perPage <= videos.length && nextPageToken) && !isLoading && <LoadMore callVideos={callVideos} />}
    </>
}
export default VideoLayout;